
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotorStaticHorizontal as ObiMotorStaticHorizontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motor-static-horizontal.js';
 
 
 

 
 export const ObiMotorStaticHorizontal = createComponent({
   react: React,
   tagName: 'obi-motor-static-horizontal',
   elementClass: ObiMotorStaticHorizontalElement,
   events: {
     
   }
  });
 
 